// Gemeinsame Aufbereitung für PDF- und Word-Export: welche Prozesse, welche Schritte, welche Nummern.
import { byId, layoutFor, processPath, processTree, readingOrder, statusOf, NODE_TYPES } from '../model.js';

export function reportModel(data, pid, { zielbild = false } = {}) {
  const roots = pid ? [pid] : data.processes.filter((p) => !p.parentId).sort((a, b) => (a.order ?? 0) - (b.order ?? 0)).map((p) => p.id);
  const seen = new Set();
  const procs = [];
  for (const r of roots) for (const p of processTree(data, r)) if (!seen.has(p.id)) { seen.add(p.id); procs.push(p); }
  const items = procs.map((p, i) => {
    const { nodes, layout, laneOrder } = layoutFor(data, p.id, { zielbild });
    const order = readingOrder(layout, nodes, laneOrder);
    const steps = order.map((n, k) => ({
      nr: k + 1,
      n,
      lane: byId(data.lanes, n.lane)?.name || n.lane,
      systeme: (n.systemIds || []).map((s) => byId(data.systems, s)?.name).filter(Boolean),
      status: statusOf(n.status)?.name || '',
      typ: NODE_TYPES.find((t) => t.id === n.typ)?.name || n.typ,
      sub: n.subprocessId ? byId(data.processes, n.subprocessId)?.titel : null,
      dec: n.decisionId ? byId(data.decisions, n.decisionId) : null,
    }));
    return {
      p,
      nr: chapterNr(data, p),
      crumb: processPath(data, p.id).map((x) => x.titel).join(' › '),
      steps,
      decisions: data.decisions.filter((d) => d.processId === p.id),
      index: i,
    };
  });
  const decisions = data.decisions.filter((d) => seen.has(d.processId));
  return { items, decisions, title: pid ? byId(data.processes, pid).titel : data.meta.titel };
}

function chapterNr(data, p) {
  const path = processPath(data, p.id);
  const nums = [];
  for (let i = 0; i < path.length; i++) {
    const sibs = data.processes.filter((x) => (x.parentId || null) === (i ? path[i - 1].id : null)).sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    nums.push(sibs.findIndex((x) => x.id === path[i].id) + 1);
  }
  return nums.join('.');
}

/** Felder eines Schritts für Detailausgaben (nur befüllte). */
export function stepFields(s) {
  const n = s.n;
  const f = [];
  f.push(['Typ', s.typ]);
  if (s.status) f.push(['Status', s.status]);
  if (s.systeme.length) f.push(['Systeme', s.systeme.join(', ')]);
  if (n.verantwortlich) f.push(['Verantwortlich', n.verantwortlich]);
  if (n.belege?.length) f.push(['Belege', n.belege.join(', ')]);
  if (n.input) f.push(['Input', n.input]);
  if (n.output) f.push(['Output', n.output]);
  if (s.sub) f.push(['Unterprozess', s.sub]);
  if (n.ausbaustufe2) f.push(['Ausbaustufe', 'Verbesserung in Ausbaustufe 2 geplant']);
  if (n.quellen?.length) f.push(['Quellen', n.quellen.map((q) => q.dokument + (q.datum ? ' (' + fmtDate(q.datum) + ')' : '')).join('; ')]);
  return f;
}

export function fmtDate(iso) {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : iso;
}
